export function isValueDefined(value) {
  return ![undefined, null].includes(value);
}